import React, {
    forwardRef,
    useState,
    useEffect,
    useImperativeHandle,
} from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import "../styles/global.css";

const CheckoutForm = forwardRef(
    (
        {
            formValues,
            paymentSucceeded,
            setPaymentSucceeded,
            setPaymentError,
            setIsDisabled,
        },
        ref
    ) => {
        const [error, setError] = useState(null);
        const [processing, setProcessing] = useState("");
        const [disabled, setDisabled] = useState(true);
        const [clientSecret, setClientSecret] = useState("");
        const stripe = useStripe();
        const elements = useElements();

        useEffect(() => {
            // Create PaymentIntent as soon as the page loads
            if (formValues.toPay) {
                window
                    .fetch(
                        "https://api.pegasuschauffeurdrive.com/create-payment-intent",
                        {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                cost: formValues.toPay,
                            }),
                        }
                    )
                    .then((res) => {
                        return res.json();
                    })
                    .then((data) => {
                        setClientSecret(data.clientSecret);
                    });
            }
        }, [formValues.toPay]);

        const cardStyle = {
            style: {
                base: {
                    color: "#32325d",
                    fontFamily: "Arial, sans-serif",
                    fontSmoothing: "antialiased",
                    fontSize: "16px",
                    "::placeholder": {
                        color: "#32325d",
                    },
                },
                invalid: {
                    fontFamily: "Arial, sans-serif",
                    color: "#fa755a",
                    iconColor: "#fa755a",
                },
            },
        };

        const handleChange = async (event) => {
            // Listen for changes in the CardElement
            // and display any errors as the customer types their card details
            setDisabled(event.empty);
            setError(event.error ? event.error.message : "");
        };

        useImperativeHandle(ref, () => ({
            handleSubmit() {
                return new Promise(async (resolve, reject) => {
                    setProcessing(true);

                    const payload = await stripe.confirmCardPayment(
                        clientSecret,
                        {
                            payment_method: {
                                card: elements.getElement(CardElement),
                            },
                        }
                    );

                    if (payload.error) {
                        setError(`Payment failed ${payload.error.message}`);
                        setProcessing(false);
                        setIsDisabled(false);
                        reject(payload.error);
                    } else {
                        setError(null);
                        setProcessing(false);
                        resolve("success"); // Resolve the promise with 'success' status
                    }
                });
            },
        }));

        return (
            <form id="payment-form">
                <CardElement
                    id="card-element"
                    options={cardStyle}
                    onChange={handleChange}
                />
                {/* <button
                disabled={processing || disabled || paymentSucceeded}
                id="submit"
            >
                <span id="button-text">
                    {processing ? (
                        <div className="spinner" id="spinner"></div>
                    ) : (
                        "Pay now"
                    )}
                </span>
            </button> */}
                {/* Show any error that happens when processing the payment */}
                {error && (
                    <div className="card-error" role="alert">
                        Payment Failed
                    </div>
                )}
                {/* Show a success message upon completion */}
                <p
                    className={
                        paymentSucceeded
                            ? "result-message text-center"
                            : "result-message hidden"
                    }
                >
                    Payment Succeeded
                </p>
            </form>
        );
    }
);

export default CheckoutForm;
